import { useEffect } from 'react';
import { Nav } from './ux/components/Nav';
import { Hero } from './ux/components/Hero';
import { Showcase } from './ux/components/Showcase';
import { Brands } from './ux/components/Brands';
import { About } from './ux/components/About';
import { Services } from './ux/components/Services';
import { Contact } from './ux/components/Contact';
import { Footer } from './ux/components/Footer';

/**
 * / — the public marketing site, served by the same Express app as the CRM.
 *
 * The public site's typography and palette are scoped to `.marketing` so
 * refinements here do not change the CRM or creator documents.
 */
export default function MarketingScreen() {
  // The app sets `color-scheme: dark` globally for the CRM. Without undoing it
  // here the browser paints dark form controls, scrollbars and autofill on top
  // of a cream page.
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.style.colorScheme;
    root.style.colorScheme = 'light';
    return () => {
      root.style.colorScheme = previous;
    };
  }, []);

  return (
    <div className="marketing bg-cream text-ink font-sans relative min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Showcase />
        <Brands />
        <About />
        <Services />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
